export default "__VITE_ASSET__90932ab6__"